import React, { useState, useMemo } from 'react';
import { 
  FaSearch, 
  FaBars, 
  FaTimes, 
  FaDownload, 
  FaEye, 
  FaLaptopCode, 
  FaRobot, 
  FaChartLine, 
  FaUserTie, 
  FaCertificate, 
  FaCalculator, 
  FaStethoscope, 
  FaCloud, 
  FaDatabase, 
  FaBolt, 
  FaFlask, 
  FaGlobe,
  FaGraduationCap,
  FaFilePdf,
  FaDraftingCompass,
  FaBookOpen,
  FaCampground,
  FaShieldAlt,
  FaLeaf,
  FaAtom,
  FaMicrochip,
  FaCog,
  FaClipboardList,
  FaBitcoin,
  FaRocket
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const CourseBrowserShowCase = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Course data with PDF links
  const courses = [
    // Technology & Programming
    {
      id: 1,
      title: "Quantum Computing",
      category: "Technology",
      description: "Master quantum computing principles, quantum algorithms, and quantum programming. Learn to build quantum applications and understand quantum supremacy.",
      icon: <FaRobot className="fs-1 text-primary" />,
      duration: "12 months",
      level: "Advanced",
/* The above code is setting the value of the `pdfUrl` property to a specific URL that points to a PDF
file. */
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Quantum_Computing%20brochure.pdf"
    },
    
    {
      id: 2,
      title: "Full Stack AI & ML Developer",
      category: "Technology", 
      description: "Complete web development training on Full stack AI-Apps/web 3.0, Rust, CUDA, Django, ReactJs,Flutter,Spring boot, Express JS,Node.js, PostgreSQL, VectorDB, SurrealDB, MongoDB, and multi-cloud deployment. Build real-world applications from scratch.",
      icon: <FaLaptopCode className="fs-1 text-success" />,
      duration: "9 months",
      level: "Intermediate",
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Full%20stack%20Ai%20%26%20ML%20Developer_program.pdf"
    },

    {
      id: 3,
      title: "AI & ML Engineering",
      category: "Technology",
      description: "Comprehensive artificial intelligence and machine learning program. Learn Python, TensorFlow, deep learning, and deploy AI models.",
      icon: <FaRobot className="fs-1 text-info" />,
      duration: "10 months", 
      level: "Advanced",
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/AI%20Agents%20%26%20LLM%20Developer%20Program.pdf"
    },
    {
      id: 4,
      title: "Cloud Computing",
      category: "Technology",
      description: "Master AWS, Azure, and Google Cloud platforms. Learn containerization, serverless computing, and cloud architecture design.",
      icon: <FaCloud className="fs-1 text-success" />,
      duration: "6 months",
      level: "Intermediate",
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/cloud%20computing.pdf"
    },
    {
      id: 5,
      title: "Data Science & Analytics",
      category: "Technology",
      description: "Complete data science program covering statistics, machine learning, big data analytics, and business intelligence tools.",
      icon: <FaChartLine className="fs-1 text-warning" />,
      duration: "9 months",
      level: "Intermediate", 
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Data%20%20Science%20%26%20Analyst_brochure.pdf"
    },
    {
      id: 6,
      title: "Database Administration",
      category: "Technology",
      description: "Expert training in SQL, NoSQL databases, performance tuning, backup strategies, and database security best practices.",
      icon: <FaDatabase className="fs-1 text-success" />,
      duration: "5 months",
      level: "Intermediate",
      pdfUrl: "/brochures/database-admin.pdf"
    },
    {
      id: 7,
      title: "Business Analyst Program",
      category: "Business",
      description: "Strategic business analysis, requirements gathering, process improvement, and stakeholder management with industry tools.",
      icon: <FaUserTie className="fs-1 text-dark" />,
      duration: "6 months",
      level: "Intermediate",
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Business%20Analyst%20%26%20PMP.pdf"
    },
    {
      id: 8,
      title: "PMP Certification",
      category: "Business",
      description: "Project Management Professional certification preparation with real-world project scenarios and PMI methodologies.",
      icon: <FaCertificate className="fs-1 text-warning" />,
      duration: "4 months",
      level: "Professional",
      pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Business%20Analyst%20%26%20PMP.pdf"
    },
    {
      id: 9,
      title: "IIT JEE Mains & Advanced",
      category: "Competitive Exams",
      description: "Comprehensive preparation for IIT Joint Entrance Examination with expert faculty and proven methodology.",
      icon: <FaCalculator className="fs-1 text-danger" />,
      duration: "2 years",
      level: "High School",
      pdfUrl: "/brochures/iit-jee.pdf"
    },
    {
      id: 10,
      title: "NEET Medical UG",
      category: "Medical",
      description: "National Eligibility cum Entrance Test preparation for undergraduate medical courses with mock tests and practice.",
      icon: <FaStethoscope className="fs-1 text-success" />,
      duration: "2 years",
      level: "High School",
      pdfUrl: "/brochures/neet-ug.pdf"
    },
    {
      id: 11,
      title: "NEET Medical PG",
      category: "Medical",
      description: "Postgraduate medical entrance examination preparation with specialized coaching and study materials.",
      icon: <FaStethoscope className="fs-1 text-info" />,
      duration: "1 year",
      level: "Graduate",
      pdfUrl: "/brochures/neet-pg.pdf"
    },
    {
      id: 12,
   title: "IIT-JAM Physics Program",
  category: "IIT JAM",
  description: "A comprehensive 12-month program designed to prepare students for the IIT-JAM Physics exam, covering advanced topics such as Quantum Mechanics, Electromagnetic Theory, Solid State Physics, and Thermodynamics. This program includes paid training and internship opportunities in collaboration with leading research institutions.",
  icon: <FaAtom className="fs-1 text-success" />,
  duration: "12 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_physics.pdf"
},
    {
      id: 13,
    title: "IIT-JAM Chemistry Program",
  category: "IIT JAM",
  description: "A comprehensive program designed to prepare students for the IIT-JAM Chemistry exam, focusing on Physical, Organic, and Inorganic Chemistry topics.",
  icon: <FaFlask className="fs-1 text-primary" />,
  duration: "Varies",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_chemistry.pdf"
},
    {
      id: 14,
      title: "IIT JAM Biotechnology",
      category: "IIT JAM",
       description: "A comprehensive program designed to prepare students for the IIT-JAM Biotechnology exam, covering key topics such as Microbiology, Biochemistry, Molecular Biology, and Genetic Engineering. This long-term program includes internship opportunities at leading research institutions.",
       icon: <FaFlask className="fs-1 text-success" />,
       duration: "12 months",
       level: "Advanced",
       pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_biotechnology.pdf"
       },
    
    {
      id: 15,
  title: "IIT-JAM Mathematics Program",
  category: "IIT JAM",
  description: "A comprehensive 12-month program designed to prepare students for the IIT-JAM Mathematics exam, covering advanced topics such as Quantum Computing, Advanced Algorithms for Satellite Modules, and Statistical Inference. This program includes paid training and internship opportunities in collaboration with leading research institutions.",
  icon: <FaCalculator className="fs-1 text-info" />,
  duration: "12 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_mathematics.pdf"
},
    {
      id: 16,
  title: "IIT-JAM Mathematical Statistics Program",
  category: "IIT JAM",
  description: "A comprehensive 12-month program designed to prepare students for the IIT-JAM Mathematical Statistics exam, covering advanced topics such as Quantum Computing, Advanced Algorithms for Satellite Modules, and Statistical Inference. This program includes paid training and internship opportunities in collaboration with leading research institutions.",
  icon: <FaCalculator className="fs-1 text-info" />,
  duration: "12 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_mathematical_statistics.pdf"
},
    {
      id: 17,
    
  title: "IIT-JAM Geology & GeoPhysics Program",
  category: "IIT JAM",
  description: "A comprehensive 12-month program designed to prepare students for the IIT-JAM Geology exam, covering key topics such as Geomorphology, Structural Geology, Paleontology, Stratigraphy, Mineralogy, Petrology, Economic Geology, and Applied Geology. This program includes internship opportunities at leading geological research institutions.",
  icon: <FaGlobe className="fs-1 text-primary" />,
  duration: "12 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_geology.pdf"
},
    
    {
      id: 18,
      title: "GRE Preparation",
      category: "International Exams",
      description: "Graduate Record Examination preparation for US university admissions with verbal, quantitative, and analytical sections.",
      icon: <FaGraduationCap className="fs-1 text-primary" />,
      duration: "4 months",
      level: "Graduate",
      pdfUrl: "/brochures/gre-preparation.pdf"
    },
    {
      id: 19,
      title: "TOEFL Training",
      category: "International Exams",
      description: "Test of English as a Foreign Language preparation with speaking, listening, reading, and writing modules.",
      icon: <FaGlobe className="fs-1 text-success" />,
      duration: "3 months",
      level: "All Levels",
      pdfUrl: "/brochures/toefl-training.pdf"
    },
    {
      id: 20,
      title: "IELTS Preparation",
      category: "International Exams",
      description: "International English Language Testing System comprehensive training for academic and general modules.",
      icon: <FaGlobe className="fs-1 text-info" />,
      duration: "3 months",
      level: "All Levels",
      pdfUrl: "/brochures/ielts-preparation.pdf"
    },
    {
      id: 21,
      title: "PTE Academic",
      category: "International Exams",
      description: "Pearson Test of English Academic preparation with computer-based testing practice and strategies.",
      icon: <FaGlobe className="fs-1 text-warning" />,
      duration: "2 months",
      level: "All Levels",
      pdfUrl: "/brochures/pte-academic.pdf"
    },
    {
      id: 22,
      title: "GMAT Preparation",
      category: "International Exams",
      description: "Graduate Management Admission Test preparation for business schools with quantitative and verbal reasoning.",
      icon: <FaUserTie className="fs-1 text-danger" />,
      duration: "5 months",
      level: "Graduate",
      pdfUrl: "/brochures/gmat-preparation.pdf"
    },
    {
      id: 23,
      title: "MCAT Training",
      category: "International Exams",
      description: "Medical College Admission Test preparation covering biological sciences, chemistry, physics, and psychology.",
      icon: <FaStethoscope className="fs-1 text-primary" />,
      duration: "6 months",
      level: "Graduate",
      pdfUrl: "/brochures/mcat-training.pdf"
    },
    {
      id: 24,
      title: "Energy Sector Engineering",
      category: "Technology",
      description: "Renewable energy systems, power generation, smart grids, and sustainable energy solutions with practical projects.",
      icon: <FaBolt className="fs-1 text-warning" />,
      duration: "8 months",
      level: "Advanced",
      pdfUrl: "/brochures/energy-engineering.pdf"
    },
    {
      id: 25,
  title: "Civil Engineering — AR/VR Applications",
  category: "Civil Engineering",
  description: "A 6-month professional program in civil engineering that integrates AR/VR for design, construction planning, and visualization. Learn to model 3D structures, simulate construction workflows, conduct virtual site surveys, and create immersive walkthroughs for smart and sustainable infrastructure projects. Emphasis on practical projects and industry applications.",
  icon: <FaCampground className="fs-1 text-primary" />,
  duration: "6 months",
  level: "Intermediate",
    pdfUrl:"https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/AI_models_ARVR_civil_program.pdf"
    },
      {
      id: 26,
  title: "Academy Brochure Jobs/Internships Programs",
  category: "Academy Brochure",
  description: "A 6-months, 9-months, 1-year, Future on demand high paying jobs (2026-2030)",
  icon: <FaBookOpen className="fs-1 text-primary" />,
  duration: "9 months",
  level: "Intermediate",
    pdfUrl:"https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/coursebrochure_academy.pdf"
    },
    {
  id: 27,
  title: "Big Data Engineer Program",
  category: "Data Engineering",
  description: "A 9-month intensive professional program with (6 months training + 3 months paid internship) covering Hadoop, Spark, Kafka, and modern data pipelines — designed to prepare industry-ready Big Data Engineers.",
  icon: <FaDatabase className="fs-1 text-success" />,
  duration: "6 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Big%20Data%20engineer%20brochure.pdf"
},
{
  id: 28,
  title: "Data Science & Analyst Program",
  category: "Technology",
  description: "A 6 to 9-month job-oriented program covering Python, Machine Learning, SQL, Power BI, and advanced data analytics techniques for real-world business insights.",
  icon: <FaChartLine className="fs-1 text-info" />,
  duration: "9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Data%20%20Science%20%26%20Analyst_brochure.pdf"
},
{
  id: 29,
  title: "DevOps Engineer Program",
  category: "Technology",
  description: "An 8 to 9-month hands-on program covering CI/CD pipelines, Docker, Kubernetes, AWS, Jenkins, Git, Terraform, and industry DevOps practices for scalable deployments.",
  icon: <FaCloud className="fs-1 text-warning" />,
  duration: "9 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Devops%20Engineer_program.pdf"
},
{
  id: 30,
  title: "Ethical Cyber Security Program",
  category: "Technology",
  description: "A 9-month intensive program covering ethical hacking, penetration testing, digital forensics, network & application security — designed to prepare you for real-world cyber-defense roles.",
  icon: <FaShieldAlt className="fs-1 text-danger" />,
  duration: "9 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Ethical_cyber_security_program.pdf"
},
{
  id: 31,
  title: "Environmental Science Internship Program",
  category: "Environmental Science",
  description: "A 3 to 6-month internship program focused on environmental research, sustainability projects, and fieldwork experience — ideal for students seeking hands-on exposure in environmental science.",
  icon: <FaLeaf className="fs-1 text-success" />,
  duration: "3–6 months",
  level: "Beginner to Intermediate",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/ENV_Science_job_internship_program.pdf"
},
{
  id: 32, 
  title: "IIT-JAM Economics Program",
  category: "IIT JAM",
  description: "A comprehensive program designed to prepare students for the IIT-JAM Economics exam, covering key topics such as Microeconomics, Macroeconomics, Statistics, and Mathematical Methods.",
  icon: <FaGraduationCap className="fs-1 text-success" />,
  duration: "Varies",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IIT-JAM_Brochures_.Economicspdf.pdf"
},
{
  id: 33,
  title: "School AI & Foundation Program (Grades 6–10th class)",
  category: "School Programs",
  description: "A future-ready long-term program integrating Artificial Intelligence, Coding, and IIT–NEET Foundation training for students from Grades 6 to 10. This program builds strong fundamentals in Mathematics, Science, and Computational Thinking while introducing AI concepts such as Machine Learning, Robotics, and Data Intelligence. Students participate in real-world AI projects, coding bootcamps, and hands-on experiments designed by IITians and industry experts. The program also includes mentorship, paid internship opportunities in AI research labs, and Olympiad preparation for STEM excellence.",
  icon: <FaRobot className='fs-1 text-primary' />,
  duration: "1–3 Years (Progressive Level Program)",
  level: "Beginner to Intermediate",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/School_Ai_Program_2025.pdf"
},
{
  id: 34,
  title: "Olewin Academy All-Courses Brochure",
  category: "Full Academy Brochure",
  description: "A comprehensive overview of all courses offered by Olewin Academy — including AI, Data Science, DevOps, Cybersecurity, Competitive Exam Foundations, School AI Programs and more.",
  icon: <FaBookOpen className="fs-1 text-primary" />,
  duration: "Varies",
  level: "All Levels",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Brochure_olewinacademy.pdf"
},
{
  id: 35,
  title: "IoT Developer Program",
  category: "IoT & Embedded Systems",
  description: "A 9-month hands-on program covering Internet of Things architecture, embedded hardware platforms, sensor networks, real-time data processing and cloud integration — designed to equip you with skills to build end-to-end IoT solutions.",
  icon: <FaMicrochip className="fs-1 text-secondary" />,
  duration: "9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/IoT%20developer%20Program.pdf"
},
{
  id: 36,
  title: "SAP Job-Oriented Technical Track",
  category: "SAP ",
  description: "A job-oriented program designed to prepare you for technical roles in the SAP ecosystem, covering modules like ABAP, Basis, SAP S/4HANA technical architecture and hands-on project training.",
  icon: <FaCog className="fs-1 text-purple" />,
  duration: "9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/SAP%20Brochures_joboriented_course_technical_track.pdf"
},
{
  id: 37,
  title: "SAP Job-Oriented Functional Track",
  category: "SAP ",
  description: "A job-oriented program focused on functional roles within the SAP ecosystem — covering modules like FI/CO, MM, SD, HCM, and more, along with industry projects and certification preparation.",
  icon: <FaClipboardList className="fs-1 text-info" />,
  duration: "9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/SAP%20Brochures_joboriented_courses_functional_program.pdf"
},
{
  id: 38,
  title: "Blockchain Technology Program",
  category: "Blockchain & Web3.0",
  description: "A comprehensive job-oriented program covering blockchain architecture, smart contracts, DApps, cryptocurrency systems and enterprise Web3 solutions — designed to prepare you for roles in the emerging blockchain ecosystem.",
  icon: <FaBitcoin className="fs-1 text-purple" />,
  duration: "9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/blockchain%20technology%20program.pdf"
},
{
  id: 39,
  title: "Space Technologies Program",
  category: "Space Tech & Satellite ",
  description: "A cutting-edge job-oriented program covering satellite systems, launch vehicle technologies, space data analytics, and mission design — preparing you for roles in the emerging space industry.",
  icon: <FaRocket className="fs-1 text-dark" />,
  duration: "9 months",
  level: "Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/space%20technologies%20program.pdf"
},
{
  id: 40,
  title: "Multi-Cloud Computing Program",
  category: "Technology",
  description: "A comprehensive 6-to-9 month professional program designed to master cloud infrastructure across multiple platforms such as AWS, Azure, and Google Cloud. The program focuses on cloud architecture, DevOps integration, containerization, cloud security, and real-time deployment practices — preparing learners for high-demand roles in cloud and DevOps engineering.",
  icon: <FaCloud className="fs-1 text-primary" />,
  duration: "6–9 months",
  level: "Intermediate to Advanced",
  pdfUrl: "https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/cloud%20computing.pdf"
}



  ];

  // Filter courses based on search term
  const filteredCourses = useMemo(() => {
    if (!searchTerm) return courses;
    return courses.filter(course =>
      course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      course.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      course.description.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  // Get unique categories
  const categories = [...new Set(courses.map(course => course.category))];

  const handleViewBrochure = (course) => {
    // Open PDF in new tab
    window.open(course.pdfUrl, '_blank');
  };

  const handleDownloadBrochure = (course) => {
    // Create download link
    const link = document.createElement('a');
    link.href = course.pdfUrl;
    link.download = `${course.title.replace(/\s+/g, '-').toLowerCase()}-brochure.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="min-vh-100 my-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="bg-white shadow-sm">
        <div className="container py-4 py-md-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between position-relative">
                <div className="d-lg-none">
                  <button 
                    className="btn btn-dark"
                    onClick={toggleMobileMenu}
                  > 
                    {isMobileMenuOpen ? <FaTimes /> : <FaBookOpen />}
                  </button>  
                </div>
                <div className="flex-grow-1 text-center my-3 py-3">
                  <h1 className="h3 h2-md display-6-lg fw-bold text-success mb-2">Academy Brochures</h1> 
                  <p className="small text-muted mb-0 d-none d-sm-block">Excellence in Education & Professional Training</p>
      <Link
  to="https://cdn.jsdelivr.net/gh/OlewinAcademy/Academy_brochures@main/materials/Brochure_olewinacademy.pdf"
  target="_blank"
  rel="noopener noreferrer"
  className="rounded-pill fw-bold w-auto text-center  btn btn-primary my-3 py-3 px-5 bg-primary text-white border-0"
>
  Full Academy Brochure
</Link>
                </div>
                  
                <div className="d-lg-none" style={{width: '52px'}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Side Menu */}
     
      <div className={`position-fixed top-0 start-0 h-100 bg-white shadow-lg ${isMobileMenuOpen ? 'd-block' : 'd-none'} d-lg-none overflow-auto`} 
           style={{ width: '280px', zIndex: 1050 }}>
        <div className="d-flex justify-content-between align-items-center p-3 border-bottom bg-dark text-white sticky-top">
          <h5 className="mb-0 fw-bold">Course Categories</h5>
          <button className="btn btn-sm btn-danger" onClick={toggleMobileMenu}>
            <FaTimes />
          </button>
        </div>
        <div className="p-3">
          {categories.map((category, index) => (
            <button 
              key={index}
              className="btn btn-outline-success w-100 mb-2 text-start"
              onClick={() => {
                setSearchTerm(category);
                setIsMobileMenuOpen(false);
              }}
            >
              {category}
            </button>
          ))}
          <hr />
          <button 
            className="btn btn-secondary w-100"
            onClick={() => {
              setSearchTerm('');
              setIsMobileMenuOpen(false);
            }}
          >
            Show All Courses
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-4">
        {/* Search Section */}
        <div className="row mb-2">
          <div className="col-lg-8 mx-auto">
              
            <div className="input-group input-group-lg shadow-sm">
              
              <span className="input-group-text bg-success text-white border-0">
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control border-0"
                placeholder="Search courses, categories, or keywords..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button 
                  className="btn btn-outline-secondary border-0"
                  onClick={() => setSearchTerm('')}
                >
                  <FaTimes />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Category Filters (Desktop) */}
        <div className="row mb-2 d-none d-lg-block">
          <div className="col-12">
            <div className="d-flex flex-wrap gap-2 justify-content-center">
              <button 
                className={`btn btn-sm ${!searchTerm ? 'btn-success' : 'btn-outline-success'}`}
                onClick={() => setSearchTerm('')}
              >
                All Courses ({courses.length})
              </button>
              {categories.map((category, index) => (
                <button 
                  key={index}
                  className={`btn btn-sm ${searchTerm === category ? 'btn-dark' : 'btn-outline-success'}`}
                  onClick={() => setSearchTerm(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Results Info */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <p className="text-muted mb-0">
                Showing {filteredCourses.length} of {courses.length} courses
                {searchTerm && ` for "${searchTerm}"`}
              </p>
              <span className="text-muted small">
                <FaFilePdf className="me-1" />
                Click to view or download brochures
              </span>
            </div>
          </div>
        </div>

        {/* Course Cards Grid - 4 per row */}
        <div className="row g-4">
          {filteredCourses.length > 0 ? (
            filteredCourses.map((course) => (
              <div key={course.id} className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                <div className="card h-100 shadow-sm border-0 course-card">
                  {/* Card Header with Icon */}
                  <div className="card-header bg-gradient-primary text-center py-1 border-0">
                    {course.icon}
                    <div className="mt-2">
                      <span className="badge bg-white text-primary px-3 py-1">
                        {course.category}
                      </span>
                    </div>
                  </div>
                  
                  {/* Card Body */}
                  <div className="card-body d-flex flex-column p-1">
                    {/* Course Title */}
                    <h5 className="card-title fw-bold text-dark mb-1 text-center">
                      {course.title}
                    </h5>
                    
                    {/* Course Description */}
                    <p className="card-text text-muted small flex-grow-1 text-center">
                      {course.description}
                    </p>
                    
                    {/* Course Details */}
                    <div className="course-meta mb-1">
                      <div className="row text-center">
                        <div className="col-6">
                          <small className="text-muted d-block">Duration</small>
                          <span className="fw-bold text-primary small">{course.duration}</span>
                        </div>
                        <div className="col-6">
                          <small className="text-muted d-block">Level</small>
                          <span className="fw-bold text-success small">{course.level}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Card Footer with Buttons */}
                  <div className="card-footer bg-transparent border-0 p-4 pt-0">
                    <div className="d-grid gap-2">
                      <button 
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => handleViewBrochure(course)}
                      >
                        <FaEye className="me-2" />
                        View Brochure
                      </button>
                      <button 
                        className="btn btn-primary btn-sm"
                        onClick={() => handleDownloadBrochure(course)}
                      >
                        <FaDownload className="me-2" />
                        Download PDF
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="text-center py-5">
                <div className="display-1 text-muted mb-3">
                  <FaSearch />
                </div>
                <h3 className="text-muted">No courses found</h3>
                <p className="text-muted">Try adjusting your search terms or browse all courses.</p>
                <button 
                  className="btn btn-primary btn-lg"
                  onClick={() => setSearchTerm('')}
                >
                  Show All Courses
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-lg-none"
          style={{ zIndex: 1040 }}
          onClick={toggleMobileMenu}
        ></div>
      )}

      {/* Custom Styles */}
      <style jsx>{`
        .course-card {
          transition: all 0.3s ease;
          border-radius: 15px;
          overflow: hidden;
        }
        
        .course-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.1) !important;
        }
        
        .bg-gradient-primary {
          background: linear-gradient(135deg,rgb(243, 243, 243) 0%,rgb(228, 228, 228) 100%) !important;
        }
        
        .course-meta {
          border-top: 1px solid #e9ecef;
          border-bottom: 1px solid #e9ecef;
          padding: 15px 0;
        }
        
        .input-group-lg {
          border-radius: 50px;
          overflow: hidden;
        }
        
        .input-group-lg .form-control:focus {
          box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);
        }
        
        @media (max-width: 768px) {
          .display-5 {
            font-size: 1.5rem;
          }
          
          .lead {
            font-size: 1rem;
          }
          
          .course-card {
            margin-bottom: 1rem;
          }
        }
        
        @media (min-width: 1200px) {
          .col-xl-3 {
            flex: 0 0 25%;
            max-width: 25%;
          }
        }
      `}</style>
    </div>
  );
};

export default CourseBrowserShowCase;